<template>
  <div id="app">
    <Spinner v-if="showSpinner"></Spinner>
    <slot v-bind:slottedLabels="slottedLabels"></slot>
  </div>
</template>
<script>
import EventBus from '@/eventBus';
import labels from '../../../labels.json';
import Spinner from '@/components/shared/Spinner';
import { mapActions, mapGetters } from 'vuex';
import { tryGetLabel, constants } from '@/utils/generic.js';
import Vue from 'vue';

export default {
  components: { Spinner },
  data() {
    return {
      slottedLabels: {},
      showSpinner: false
    };
  },
  computed: {
    ...mapGetters('generic', ['appVersion']),
    ...mapGetters('login', ['loginState']),
    ...mapActions('login', ['logout', 'refreshToken'])
  },
  async created() {
    Vue.prototype.$tryGetLabel = tryGetLabel;

    // app version management
    const appVersionStored = localStorage.getItem(constants.APP_VERSION_LK);
    if (!appVersionStored)
      localStorage.setItem(constants.APP_VERSION_LK, this.appVersion);
    if (appVersionStored && appVersionStored != this.appVersion) {
      this.logout();
    }

    EventBus.$on('showSpinner', show => {
      this.showSpinner = show;
    });

    EventBus.$on('refreshToken', async () => {
      // debugger; // eslint-disable-line no-debugger
      // typeof check will avoid the error on app startup
      if (
        this.loginState &&
        this.loginState.refreshToken &&
        typeof this.refreshToken == 'function'
      )
        await this.refreshToken(this.loginState.refreshToken);
    });

    setTimeout(async () => {
      let lang = 'it-IT';
      if (process.env.APP_NAME.endsWith('FR')) lang = 'fr-FR';
      if (process.env.APP_NAME.endsWith('EN')) lang = 'en-EN';
      this.slottedLabels = labels[lang];
      this.setLabels(labels[lang]);
    }, 1000);
  },
  methods: {
    ...mapActions('login', ['redirectUnauthorizedUser']),
    ...mapActions('generic', ['getLabels', 'setLabels']),
    async loadLabels() {
      this.slottedLabels = await this.getLabels('it-IT');
      EventBus.$on('unauthorized', async () => {
        this.$store.replaceState({
          generic: {},
          bookingFunnel: {},
          washingsHistory: {},
          garage: {},
          login: {},
          vehicles: {},
          vehicleConfigurator: {}
        });
        this.redirectUnauthorizedUser();
      });
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
